import { UploadOutlined } from "@ant-design/icons";

import { Button, Layout, Spin } from "antd";
import React, { useContext } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";

import { NaocDailyProductionUpload } from "./NaocDailyProductionUpload";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { observer } from "mobx-react-lite";
import { SQuery } from "./SQuery";
import { ProductionGrid } from "./ProductionGrid";
import { ProgressIndicator } from "@fluentui/react";
import { RemarkPane } from "./RemarkPane";
import { SummaryAsExcelRpt } from "./SummaryAsExcelRpt";
import { RequestDialog } from "../approvals/RequestDialog";
import { NaocDailyProductionDetail } from "../approvals/naoc/NaocDailyProductionDetail";
import { RythmBaseView } from "./visualizations/oil-rythm-plots/RythmBaseView";

const { Content } = Layout;

export const NaocDailyProduction = observer(({ permission }) => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);

  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #E64C3C",
      }}
    >
      <Content>
        <Spin
          spinning={naocDailyProductionStore.isOpeningNaocOilRythmDrawer}
          tip="Loading NAOC Production and Evacuation Rythm..."
          fullscreen
        />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm5">
              <SubPageHeaderTitle
                title={`${naocDailyProductionStore.gridHeaderText}`}
              />
            </div>
            <div className="ms-Grid-col ms-sm3">
              {naocDailyProductionStore.isExporting && (
                <ProgressIndicator
                  description="exporting, please wait..."
                  styles={{ root: { textAlign: "center" } }}
                ></ProgressIndicator>
              )}
            </div>
            <div className="ms-Grid-col ms-sm4" style={{ textAlign: "right" }}>
              {naocDailyProductionStore.dailyProductions.size > 0 &&
                permission.canUpdate && (
                  <Button
                    type="primary"
                    icon={<UploadOutlined />}
                    onClick={() => {
                      naocDailyProductionStore.clearFormValues();
                      naocDailyProductionStore.sheetName = "";
                      naocDailyProductionStore.showNaocDailyProductionDialog = true;
                    }}
                  >
                    Upload NAOC Daily Flash Production & Evacuation
                  </Button>
                )}
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProductionGrid permission={permission} />
            </div>
          </div>
        </div>

        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {/* OTHER COMPONENTS WRAPPERS */}
            <NaocDailyProductionUpload />
            <SQuery />
            <RemarkPane />
            <SummaryAsExcelRpt />
            <RequestDialog />
            <NaocDailyProductionDetail />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {/* PLOT WRAPPERS */}
            <RythmBaseView />
          </div>
        </div>
      </Content>
    </Layout>
  );
});

